<template>
  <div class="block">
    <div>
      <div class="w-full">
        <t-field>
          <div class="flex justify-between">
            <div class="text-sm font-bold pb-2">Choose folder</div>
          </div>
          <path-autocomplete @input="handleSearchSelect" :value="pathTerm" />
        </t-field>

        <t-field>
          <div class="flex justify-between">
            <div class="text-sm font-bold pb-2">Do you want to create, edit and delete notes with this API?</div>
          </div>
          <div class="flex">
            <input type="checkbox" v-model="isApiEditable" class="mr-2" />
            <label class="text-sm">Yes</label>
          </div>
        </t-field>
      </div>
    </div>
  </div>
</template>

<script>
 import {mapState} from 'vuex';
 import { DateTime } from 'luxon';

 import api from '@/api';

 import QueryName from '@/components/QueryName';
 
 import PathAutocomplete from '@/components/PathAutocomplete';
 import spellHelper from './spellHelper';


 export default {
   props: {
     value: {
       type: Object,
       default: () => ({is_readonly: true, folder: '/'})
     },
     defaultPath: {
       type: String,
       default: '/'
     },
   },
   data () {
     return {
       isApiEditable: !this.value.is_readonly,
       pathTerm: this.value.folder || '/',
       error: '',
     }
   },

   components: {PathAutocomplete, QueryName },

   mounted () {
     if (this.spellKind === 'NOTE') {
       this.mountCM();
     }
   },

   computed: {
     ...mapState({
       paths: state => state.pathsList,
       member: state => state.member,
     })
   },

   methods: {

     entitySearch (input) {
       return this.paths.filter(p => {
         return p.startsWith(input)
       })
     },

     handleSearchSelect (r) {
       this.pathTerm = r;
       this.$emit('input', {
         folder: this.pathTerm,
         is_readonly: !this.isApiEditable
       })
     },
   },

   watch: {
     isApiEditable (to) {
       this.$emit('input', {
         folder: this.pathTerm,
         is_readonly: !to
       })
     }
   }
 }

</script>
